import { Visitable } from './Visitable';
import { Visitor } from './Visitor';
import Contact from './Contact';
import { Bookings } from './Bookings';
import * as Type from '../types/RequestTypes';
import TestType from './TestType';
import { isNullOrUndefined } from '../utils';
import dayjs from 'dayjs';

export default class Request implements Visitable {
    private  _id: number = 0;
    private _created: dayjs.Dayjs = {} as dayjs.Dayjs;
    private _deleted: dayjs.Dayjs = {} as dayjs.Dayjs;
    private _customerId: number = 0;
    private _endDate: dayjs.Dayjs = {} as dayjs.Dayjs;
    private _ipAddress: string = '';
    private _lastUpdate: dayjs.Dayjs = {} as dayjs.Dayjs;
    private _maxTests: number = 0;
    private _registrar: string = '';
    private _succeededDate: dayjs.Dayjs = {} as dayjs.Dayjs;
    private _contact: Contact = {} as Contact;
    private _links: Type.RequestType.RequestLinks = {} as Type.RequestType.RequestLinks;
    private _status: string = '';
    private _bookings?: Bookings = undefined;
    private _testType?: TestType = undefined;

    set created(date: dayjs.Dayjs) {
        this._created = date;
    }

    get created(): dayjs.Dayjs {
        return this._created;
    }

    set deleted(date: dayjs.Dayjs) {
        this._deleted = date;
    }

    get deleted(): dayjs.Dayjs {
        return this._deleted;
    }

    set endDate(date: dayjs.Dayjs) {
        this._endDate = date;
    }

    get endDate(): dayjs.Dayjs {
        return this._endDate;
    }

    get ipAddress(): string {
        return this._ipAddress;
    }

    set ipAddress(address: string) {
        this._ipAddress = address;
    }

    set links(links: Type.RequestType.RequestLinks) {
        this._links = links;
    }

    get links() {
        return this._links;
    }

    get lastUpdate(): dayjs.Dayjs {
        return this._lastUpdate;
    }

    set lastUpdate(update: dayjs.Dayjs) {
        this._lastUpdate = update;
    }

    get maxTests(): number {
        return this._maxTests;
    }

    set maxTests(maxT: number) {
        this._maxTests = maxT;
    }

    get registrar(): string {
        return this._registrar;
    }

    set registrar(reg: string) {
        this._registrar = reg;
    }

    get customerId(): number {
        return this._customerId;
    }

    set customerId(customerId: number) {
        this._customerId = customerId;
    }

    get succededDate(): dayjs.Dayjs {
        return this._succeededDate;
    }

    set succededDate(date: dayjs.Dayjs) {
        this._succeededDate = date;
    }

    set contact(newContact: Contact) {
        this._contact = newContact;
    }
    get contact(): Contact {
        return this._contact;
    }

    set bookings(bookings: Bookings | undefined) {
        this._bookings = bookings;
    }

    get bookings(): Bookings | undefined {
        return this._bookings;
    }

    set testType(testType: TestType | undefined) {
        this._testType = testType;
    }

    get testType(): TestType | undefined {
        return this._testType;
    }

    set status(status: string) {
       this._status =
           (!isNullOrUndefined(status) ? status : 'pending' );
    }

    get status(): string {
        return this._status;
    }

    set id(id: number) {
        this._id = id;
    }

    get id(): number {
        return this._id;
    }

    public clone(request: Request) {
        this._created = request.created;
        this._contact = request.contact;
        this._registrar = request.registrar;
        this._links = request.links;
        this._endDate = request.endDate;
        this._ipAddress = request.ipAddress;
        this._succeededDate = request.succededDate;
        this._lastUpdate = request.lastUpdate;
        this._maxTests = request.maxTests;
        this._id = request.id;
        this._status = (!isNullOrUndefined(request.status) ? request.status : 'pending');
        this._deleted = request.deleted;
    }

    public accept(visitor: Visitor): void {
        visitor.visitRequest(this);
    }

}